import React from "react";
import PropTypes from "prop-types";
import { Actions } from "./style";

export var ModalActions = function ModalActions(_ref) {
  var children = _ref.children;
  return React.createElement(
    Actions,
    null,
    children
  );
};

ModalActions.propTypes = {
  children: PropTypes.node.isRequired
};